import type { CSSProperties, ReactNode } from 'react';
import { C } from '../../theme';

// Les champs de saisie partages par les formulaires de Colette (corriger une proposition,
// modifier un evenement). Ils vivaient dans FormulaireCorrection : les deux formulaires
// doivent se ressembler EXACTEMENT, donc leurs champs sont les memes objets.

export const styleChamp: CSSProperties = {
  width: '100%',
  height: 42,
  border: `1px solid ${C.bordure}`,
  borderRadius: 11,
  padding: '0 12px',
  // 16 px minimum : en dessous, les navigateurs mobiles zooment a la mise au point.
  fontSize: 16,
  fontFamily: 'inherit',
  color: C.encre,
  background: C.carte,
  outline: 'none',
};

export function Champ({ libelle, children }: { libelle: string; children: ReactNode }) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <span style={{ fontSize: 11.5, fontWeight: 800, letterSpacing: 0.6, color: C.tertiaire }}>
        {libelle.toUpperCase()}
      </span>
      {children}
    </label>
  );
}
